import template from './virtual_machines.html';

//Instantiate Page Variables 
var Virtual_MachinesViewModel = function(page)
{
	var self = this;
	self.page = page;
}

//Handle interaction with page 
var Virtual_Machines = function(bindings) {
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new Virtual_MachinesViewModel(this);
	this.name = 'Virtual Machines';

	document.title = this.name;

	//Event (Post/After): Load once
	this.init = function() {
		var control_panel_formatter = function(value, row, index) {
			var ret = [];
			
			if (row.status == 'Started')
			{
				ret.push([`
				<button class="btn btn-default btn-xs control-panel" title="Control Panel">
							<span class="glyphicon glyphicon-th-list"></span>
				</button>`].join(''));

			}
			return ret.join('');
		};
		var control_panel_events = {
			'click .product_start': function(e, value, row, index) {
				if (row.status == 'Stopped' || row.status == 'Installed')
				{
					$.postJSON('sysctl/start', {system_name: row.system_account_name, installation_uuid: row.installation_uuid}, function(response) {
						if (response.status != 'OK')
						{
							Grape.alert({title: 'Error', type: 'error', message: response.message});
						}
						self.updateData();
					});
				}
				else
				{
					Grape.alert({title: 'Notice', type: 'info', message: "Not able to start"});
				}
			},
			'click .product_stop': function(e, value, row, index) {
				if (row.status == 'Started')
				{
					$.postJSON('sysctl/stop', {system_name: row.system_account_name, installation_uuid: row.installation_uuid}, function(response) {
						if (response.status != 'OK')
						{
							Grape.alert({title: 'Error', type: 'error', message: response.message});
						}
						self.updateData();
					});
				}
				else
				{
					Grape.alert({title: 'Notice', type: 'info', message: "Not able to stop"});
				}
			},
			'click .installation_log': function(e, value, row, index) {
				let url = '/installation/download_install_log?system_name=' + row.system_account_name + '&installation_uuid=' + row.installation_uuid;
				window.open(url);
			},
			'click .product_log': function(e, value, row, index) {
				let url = '/installation/download_product_log?system_name=' + row.system_account_name + '&installation_uuid=' + row.installation_uuid;
				window.open(url);
			},
			'click .product_delete': function(e, value, row, index) {
				$.postJSON('installation/uninstall', {system_account_name: row.system_account_name, installation_uuid: row.installation_uuid}, function(response) {
					if (response.status != 'OK')
					{
						Grape.alert({title: 'Error', type: 'error', message: response.message});
					}
					self.updateData();
				});
			},
			'click .control-panel': function(e, value, row, index) {
				Grape.show_dialog('ControlPanel', {status: row.status, account_installation_id: row.account_installation_id,product_name:row.product_name}, { onClose: function(d) {
					self.updateData();
				} });
			}
		};

		//COMPONENT: Bootstrap Table
		self.tbl_table = $("#tbl_table").bootstrapTable({
			columns: [
				{field: 'virtual_machine_name', title: 'Virtual Machine', sortable: true, width: ''},
				{field: 'disk_size', title: 'Disk Size', sortable: true, width: ''},
				{field: 'disk_ram', title: 'Ram', sortable: true, width: ''},
				{field: 'vcpu', title: 'No of CPUs', sortable: true, width: ''},
				{field: 'site_name', title: 'Site Name', sortable: true, width: ''},
				{field: 'site_ip', title: 'Site IP', sortable: true, width: ''},
				{field: 'site_location', title: 'Site Location', sortable: true, width: ''},
				{field: 'status', title: 'Status', sortable: true, width: '',formatter: function(value, row, index) { 
					if(row.status == 'Installing'){
					return `<span><object class="loader" type="image/svg+xml" data="../../images/loader.svg"></span></object>&nbsp<span style="position: absolute;padding: 8px;">${row.status} </span>`;
					}

					if(row.status == 'Started'){
						return `<span class="glyphicon glyphicon-ok" style="color: #32CD32">&nbsp</span><span>${row.status} </span>`;
					}

					if(row.status == 'Error'){
						return `<span class="glyphicon glyphicon-exclamation-sign" style="color: #ed1b2e">&nbsp</span><span>${row.status} </span>`;
					}
				}}
			],

			dataField: 'records',

			//TABLE PROPERTIES: Paging
			pagination: true,
			pageList: [20, 50, 100],
			pageSize: 20,
			sidePagination: 'server',
			onPageChange: function(number, size) {
				self.updateData();
			},

			//TABLE PROPERTIES: Sort
			sortOrder: 'asc',
			sortName: 'virtual_machine_name',
			onSort: function(sortName, sortOrder) {
				self.updateData({sort_column: sortName, sort_order: sortOrder});
			},

			//TABLE PROPERTIES: Search
			search: false,
			searchOnEnterKey: true,
			onSearch: function(text) {
				self.updateData();
			}
		});

	};

	this.btnAddVM_click = function(model, e) {
		Grape.show_dialog('AddVM', {}, { onClose: function(d) {
			self.updateData();
		} });
	};

	//Event (Post/After): Refresh page data
	this.updateData = function(_obj) {
		var obj = {};

		if (typeof _obj != 'undefined')
		{
			obj = _obj;
		}
		$.getJSON('/get_virtual_machines', obj, function(response) {
			if (response.list == null)
				response.list = [];
			$("#tbl_table").bootstrapTable('load', {records: response.list});

			//Update status on list
			_.forEach(response.list, (obj) => {
				if(obj.status == 'Installing'){
					$.getJSON(`/installation_virtual_machine/status/`, {virtual_machine_id: obj.virtual_machine_id}, function(res) {
						if(res){
							self.updateData();
						}
					});
				}
			});
		});
	};

	//Event (Pre/Before): Remove 
	this.teardown = function() {

	};

};

export default {
	route: '[/]virtual_machines', 
	page_class: Virtual_Machines,
	template: template
};

